import type { ReactNode } from 'react';
import { formatMoney, isNegative } from '@/lib/money';
import { cn } from '@/lib/utils';

/**
 * Valor em reais, sempre com algarismos alinhados. Desconhecido não é zero (regra do domínio):
 * `null` mostra `missing` — por padrão um traço; num custo, "sem custo" em tom de aviso.
 * `signed` pinta o negativo de perigo, para prejuízo e margem abaixo de zero.
 */
export function MoneyValue({
  value,
  missing = '—',
  signed = false,
  className,
}: {
  value: string | null | undefined;
  missing?: ReactNode;
  signed?: boolean;
  className?: string;
}) {
  if (value === null || value === undefined) return <>{missing}</>;
  return (
    <span className={cn('tabular', signed && isNegative(value) && 'text-danger-ink', className)}>
      {formatMoney(value)}
    </span>
  );
}
